import Vue from "vue"
import VueRouter from "vue-router"
import { isLoggedIn } from "@/utils/auth"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/sso",
    name: "sso",
    component: () => import("@/views/sso/index.vue")
  },
  {
    path: "/douyin-callback",
    name: "douyin-callback",
    component: () => import("@/views/douyin-callback/index.vue")
  },
  {
    path: "/douyin-authorize",
    name: "douyin-authorize",
    component: () => import("@/views/douyin-authorize/index.vue")
  },
  {
    path: "/douyin-publish",
    name: "douyin-publish",
    component: () => import("@/views/douyin-publish/index.vue")
  },
  {
    path: "/editor",
    redirect: "/video-process/ai"
  },
  {
    path: "/video-process/ai",
    name: "ai-editor",
    component: () => import("@/views/editor/index.vue")
  },
  {
    path: "/video-process/manual",
    name: "manual-process-home",
    component: () => import("@/views/manual/home/index.vue")
  },
  {
    path: "/video-process/manual/intake",
    name: "manual-process-intake",
    component: () => import("@/views/manual/intake/index.vue")
  },
  {
    path: "/video-process/manual/sample",
    name: "manual-process-sample",
    component: () => import("@/views/manual/sample/index.vue")
  },
  {
    path: "/video-process/manual/guide",
    redirect: "/video-process/manual/upload"
  },
  {
    path: "/video-process/manual/upload",
    name: "manual-process-upload",
    component: () => import("@/views/manual/upload/index.vue")
  },
  {
    path: "/video-process/manual/delivery",
    name: "manual-process-delivery",
    component: () => import("@/views/manual/delivery/index.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const passThroughRoutes = ["/login", "/sso", "/douyin-callback", "/douyin-authorize", "/douyin-publish"]
  if (passThroughRoutes.includes(to.path)) {
    next()
    return
  }

  if (!isLoggedIn()) {
    next("/login")
    return
  }
  next()
})

export default router
